<template>
  <div class="container">
    <div class="row">
      <div class="col-xs-6">
        <help-text>
          <h3>
            Create Publication
          </h3>

          <p>
            Enter the details of the publication.
          </p>
        </help-text>
      </div>

      <div class="col-xs-18">
        <div class="panel panel-default">
          <div class="panel-body">
            <form @submit.prevent="submit" class="form-horizontal">
              <TextFormGroup
                  v-model="data.name"
                  name="name"
                  label="Name"
                  help-text="The name of the publication."
                  :error="getError('name')"
              />

              <TextFormGroup
                  v-model="data.theme"
                  name="theme"
                  label="Theme"
                  help-text="The theme of the publication."
                  :error="getError('theme')"
              />

              <TextareaFormGroup
                  v-model="data.theme_description"
                  name="theme_description"
                  label="Theme Description"
                  help-text="The description of the publication's theme."
                  :error="getError('theme_description')"
              />

              <TextFormGroup
                  v-model="data.target"
                  name="target"
                  label="Target"
                  help-text="The sales target for the publication."
                  :error="getError('target')"
              />

              <TextFormGroup
                  v-model="data.management_target"
                  name="management_target"
                  label="Management Target"
                  help-text="The management sales target for the publication."
                  :error="getError('management_target')"
              />

              <DateFormGroup
                  v-model="data.publish_at"
                  name="publish_at"
                  label="Publish At"
                  help-text="The date that the publication is published."
                  format="DD.MM.YYYY"
                  :error="getError('publish_at')"
              />

              <DateFormGroup
                  v-model="data.content_deadline_at"
                  name="content_deadline_at"
                  label="Content Deadline At"
                  help-text="The deadline for receiving content for the ads."
                  format="DD.MM.YYYY"
                  :error="getError('content_deadline_at')"
              />

              <DateFormGroup
                  v-model="data.content_deadline_reminder_at"
                  name="content_deadline_reminder_at"
                  label="Content Deadline Reminder At"
                  help-text="The date that the reminders for submitting ad content should be sent out."
                  format="DD.MM.YYYY"
                  :error="getError('publish_at')"
              />

              <hr>

              <SubmitFormGroup button-class="btn-black"/>
            </form>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import http from '@/http'
import moment from 'moment'
import notify from '@/notify'
import DateFormGroup from '@/vendor/forms/FormGroups/Horizontal/Date'
import Errors from '@/mixins/Errors'
import HelpText from '@/components/HelpText'
import Load from '@/mixins/Load'
import NumberFormGroup from '@/vendor/forms/FormGroups/Horizontal/Number'
import SubmitFormGroup from '@/vendor/forms/FormGroups/Horizontal/Submit'
import TextFormGroup from '@/vendor/forms/FormGroups/Horizontal/Text'
import TextareaFormGroup from '@/vendor/forms/FormGroups/Horizontal/Textarea'

export default {
  components: {DateFormGroup, HelpText, NumberFormGroup, SubmitFormGroup, TextFormGroup, TextareaFormGroup},

  mixins: [Errors, Load],

  model: {
    prop: 'portal',
    event: 'portal-updated'
  },

  props: ['portal', 'publicationBasedChannelId'],

  data() {
    return {
      publicationBasedChannel: null,
      data: {
        publish_at: null,
        content_deadline_at: null,
      }
    }
  },

  watch: {
    'data.publish_at'(value) {
      this.data.content_deadline_at = moment(value)
          .subtract(this.publicationBasedChannel.attributes.default_content_deadline_period, 'days')
          .format('YYYY-MM-DD')
    },

    'data.content_deadline_at'(value) {
      this.data.content_deadline_reminder_at = moment(value)
          .subtract(this.publicationBasedChannel.attributes.default_content_deadline_reminder_period, 'days')
          .format('YYYY-MM-DD')
    }
  },

  mounted() {
    http.get('/api/v2/publication-based-channels/' + this.publicationBasedChannelId).then(response => {
      this.publicationBasedChannel = response.data.data

      this.loading = false
    })
  },

  methods: {
    submit() {
      http.post('/api/v2/publications', {...this.data, publication_channel_id: this.publicationBasedChannelId})
          .then(() => {
            notify.success('The publication was saved')

            this.$router.push('/portals/' + this.portal.id + '/publication-based-channels/' + this.publicationBasedChannelId)
          })
          .catch(this.catchValidationErrors)
    }
  }
}
</script>
